import { print } from 'graphql';
import Vue from 'vue';
import api from './repository';
import UPDATE_CUSTOMER_MUTATION from './queries/customer/update';

export default {
  async updateCustomer(customer) {
    try {
      const response = await api.post('/graphql/', {
        query: print(UPDATE_CUSTOMER_MUTATION),
        variables: {
          customerId: customer.customerId,
          maritalStateId: customer.maritalState ? customer.maritalState.maritalStateId : undefined,
          startDateCareer: customer.startDateCareer ? Vue.moment(customer.startDateCareer).format('YYYY-MM-DD') : undefined,
          totalGrossRemuneration2020: customer.totalGrossRemuneration2020,
          monthsIndependentBefore2021: customer.monthsIndependentBefore2021,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
};
